import { default as es } from "./es";

export default { es };
